import type { ChoiceOption } from '@/shared/lib/choice-option';

// Pronouns are stored as one free-text string, so "Other" is a UI-only fourth choice layered on
// top of these three; see `shared/lib/derive-pronoun-selection.ts`.
export const PRONOUN_OPTIONS: ChoiceOption[] = [
    { value: 'he/him', label: 'He/him' },
    { value: 'she/her', label: 'She/her' },
    { value: 'they/them', label: 'They/them' },
];

export const OTHER_PRONOUN_CHOICE = 'other';
